import { PretaxClaimPaymentMethod } from 'constants/claims';

import { gatewayClient } from '../utils/gatewayClient';

export type AlegeusEmployeeAsDependent = {
  dependent_id: string;
  last_name: string;
  middle_initial: string;
  employee_full_name: string;
  relationship: string;
  first_name: string;
};

export interface FetchPretaxClaimByIdResponse {
  claim: {
    claim_amount: number;
    claim_category: string;
    claim_description: string;
    claim_status: string;
    created: string;
    note: string;
    service_start_date: string;
    transaction_date: string;
    receipts_info: Array<{ FileKey: string }>;
    claimant: {
      first_name: string;
    };
  };
}
export function fetchPretaxClaimById({ id }: { id: string }) {
  return gatewayClient.get<FetchPretaxClaimByIdResponse>(
    `/cdh/v2/claims/${id}`
  );
}

export interface FetchPretaxClaimReceiptByIdResponse {
  receipt: {
    Base64: string;
    FileName: string;
  };
}
export function fetchPretaxClaimReceiptById(file_key: string) {
  return gatewayClient.get<FetchPretaxClaimReceiptByIdResponse>(
    `/cdh/v2/claims/receipts/${file_key}`
  );
}

export interface FetchPretaxClaimsResponse {
  claims: Array<{
    id: string;
    description: string;
    claim_amount: number;
    claim_amount_approved?: number;
    claim_status: string;
    created: string;
    settlement_date?: number;
    seq_number?: number;
    transaction_id?: string;
    reimbursement_method:
      | PretaxClaimPaymentMethod.DIRECT_DEPOSIT
      | PretaxClaimPaymentMethod.CHECK
      | PretaxClaimPaymentMethod.NONE;
  }>;
}
export function fetchPretaxClaims({ year }: { year?: string }) {
  return gatewayClient.get<FetchPretaxClaimsResponse>(`/cdh/v2/claims`, {
    params: {
      year,
    },
  });
}

export function createPretaxClaim({
  amount,
  category,
  claimant,
  default_employee_wallet_id,
  note,
  receipt,
  reimbursement_vendor,
  transaction_date,
  account_id,
}: {
  amount: number;
  category: string;
  claimant: string | AlegeusEmployeeAsDependent;
  default_employee_wallet_id: string;
  note: string;
  receipt: Array<{
    base64: string;
    content_type: string | null;
    file_name: string;
  }>;
  reimbursement_vendor: string;
  transaction_date: string;
  account_id: string;
}) {
  return gatewayClient.post('/cdh/v2/claims', {
    amount,
    category,
    claimant,
    default_employee_wallet_id,
    note,
    receipt,
    reimbursement_vendor,
    transaction_date,
    account_id,
  });
}

export function createPretaxV2Claim({ data }: { data: FormData }) {
  return gatewayClient.post('/pretax/claims', data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}
